export enum AdditionalDocumentType {
  NotSelected = 0,
  Passport = 1,
  IdentityCard = 2,
  InternationalPassport = 3,
  ResidencePermit = 4,
  INN = 5,
  MilitaryId = 6,
  DriverLicense = 7,
  IdCard = 8,
  StudentId = 9,
  Diploma = 10,
  TempResidencePermit = 11,
  ForeignResidencePermit = 12,
  MilitaryRegistrationCertificate = 13,
}
